import state from "./moduleReceiveMailState";
import mutations from "./moduleReceiveMailMutations";
import actions from "./moduleReceiveMailActions";
import getters from "./moduleReceiveMailGetters";

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}